import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { RequestService } from '@services/http/request.service';
import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'app-chad-sidebar',
  templateUrl: './chad-sidebar.component.html',
  styleUrls: ['./chad-sidebar.component.scss']
})
export class ChadSidebarComponent implements OnInit, OnChanges {
  @Input() isOpen = false;
  @Output() closeSidebarEvent = new EventEmitter<void>();
  
  userList: any[] = [];
  filteredUserList: any[] = [];
  userType = '';
  currentUserId: number | null = null;
  selectedVendorId: number | null = null;
  selectedUserType: string = '';
  conversationId: number | null = null;
  showChatBox = false;
  subject = '';
  message = '';
  isSending = false;
  messages: any[] = [];
  loadingMessages = false;
  searchQuery = '';
  searchTimeout: any;
  lastSubject = '';

  constructor(
    private request: RequestService,
    private auth: AuthService
  ) { }

  ngOnInit(): void {
    const userData = this.auth.getUserdata();
    this.userType = userData.user_type;
    this.currentUserId = userData.user_id;
    console.log('Current user:', userData);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      if (changes['isOpen'].currentValue === true) {
        this.loadUserList();
        // Prevent body scroll when sidebar is open
        document.body.style.overflow = 'hidden';
      } else {
        // Restore body scroll when sidebar is closed
        document.body.style.overflow = '';
      }
    }
  }

  loadUserList() {
    const endpoint = this.userType === 'admin' ? 'vendor-staff/list-by-country' : 'admins-dropdown';
    const params = this.searchQuery ? { keyword: this.searchQuery } : {};
    console.log('Loading user list from:', endpoint, 'User type:', this.userType, 'Search:', this.searchQuery);
    this.request.GET(endpoint, params).subscribe(
      (response: any) => {
        console.log('=== FULL API Response ===', JSON.stringify(response, null, 2));
        console.log('Response status:', response['status']);
        console.log('Response records:', response['records']);
        console.log('Response records type:', typeof response['records']);
        
        if (response['status']) {
          // For admin, data comes under records.vendors
          if (this.userType === 'admin') {
            const data = response['records'];
            console.log('Data:', data);
            console.log('Data.vendors:', data?.vendors);
            console.log('Data.vendors type:', typeof data?.vendors);
            console.log('Data.vendors is array?', Array.isArray(data?.vendors));
            
            let vendors = data?.vendors || [];
            
            // Check if vendors is an object with country keys (e.g., {"Panama": [...], "India": [...]})
            if (vendors && typeof vendors === 'object' && !Array.isArray(vendors)) {
              console.log('Vendors is object with keys:', Object.keys(vendors));
              // Flatten all country arrays into one
              vendors = Object.keys(vendors).reduce((acc, country) => {
                console.log(`Processing country: ${country}, items:`, vendors[country]?.length || 0);
                if (Array.isArray(vendors[country])) {
                  return acc.concat(vendors[country]);
                }
                return acc;
              }, []);
            }
            
            console.log('Final vendor list length:', vendors.length);
            console.log('First 3 vendors:', vendors.slice(0, 3));
            this.userList = vendors;
          } else {
            // For non-admin, data comes directly in response.data
            this.userList = response['data'] || [];
          }
          this.filteredUserList = this.userList;
          console.log('=== filteredUserList length ===:', this.filteredUserList.length);
        }
      },
      (err) => {
        console.error('Error loading user list:', err);
      }
    );
  }

  onSearchChange() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.loadUserList();
    }, 500);
  }

  selectUser(user: any) {
    console.log('Selected user:', user);
    this.selectedVendorId = user.id;
    this.selectedUserType = user.user_type || '';
    this.conversationId = user.conversation_id || null;
    this.showChatBox = true;
    this.subject = '';
    this.message = '';
    this.messages = [];
    this.lastSubject = '';
    
    if (this.conversationId) {
      this.markConversationAsSeen();
      this.loadMessages();
    } else {
      // No conversation yet, show empty chat
      this.messages = [];
    }
  }

  markConversationAsSeen() {
    if (!this.conversationId) return;
    
    this.request.POST(`chat/conversations/${this.conversationId}/seen`, {}).subscribe(
      (response: any) => {
        console.log('Conversation marked as seen:', response);
        // Update the local user list to reflect seen status
        const user = this.userList.find(u => u.conversation_id === this.conversationId);
        if (user) {
          user.seen = true;
          user.unseen = false;
          user.unread_count = 0;
        }
        const filteredUser = this.filteredUserList.find(u => u.conversation_id === this.conversationId);
        if (filteredUser) {
          filteredUser.seen = true;
          filteredUser.unseen = false;
          filteredUser.unread_count = 0;
        }
      },
      (err) => {
        console.error('Error marking conversation as seen:', err);
      }
    );
  }

  loadMessages() {
    if (!this.conversationId) return;
    
    this.loadingMessages = true;
    this.request.GET(`chat/conversations/${this.conversationId}/messages`, {}).subscribe(
      (response: any) => {
        console.log('Messages loaded:', response);
        console.log('Current User ID:', this.currentUserId, 'Type:', typeof this.currentUserId);
        if (response['status']) {
          this.messages = response['records'] || [];
          this.lastSubject = this.getLastSubjectFromMessages();
          // Debug: Check sender_id types
          this.messages.forEach(msg => {
            console.log('Message sender_id:', msg.sender_id, 'Type:', typeof msg.sender_id, 'Match:', msg.sender_id === this.currentUserId);
          });
        }
        this.loadingMessages = false;
      },
      (err) => {
        console.error('Error loading messages:', err);
        this.loadingMessages = false;
      }
    );
  }

  backToList() {
    this.showChatBox = false;
    this.selectedVendorId = null;
    this.selectedUserType = '';
    this.conversationId = null;
    this.messages = [];
    // Reload the user list to get updated seen status
    this.loadUserList();
  }

  getLastSubjectFromMessages(): string {
    for (let i = this.messages.length - 1; i >= 0; i--) {
      const subject = (this.messages[i]?.subject || '').trim();
      if (subject) {
        return subject;
      }
    }
    return '';
  }

  /** Subject to send: typed value, else last subject. Empty only when neither exists. */
  getSubjectForApi(): string {
    const typed = this.subject.trim();
    if (typed) {
      return typed;
    }
    return this.lastSubject || this.getLastSubjectFromMessages();
  }

  canSendMessage(): boolean {
    if (!this.message.trim() || this.isSending) {
      return false;
    }
    // Subject required only when there is no previous subject to reuse
    return !!(this.subject.trim() || this.lastSubject || this.getLastSubjectFromMessages());
  }

  sendMessage() {
    if (!this.canSendMessage()) {
      return;
    }

    const subjectToSend = this.getSubjectForApi();
    if (!subjectToSend) {
      return;
    }

    this.isSending = true;
    const payload: any = {
      subject: subjectToSend,
      context_type: null,
      context_id: 1,
      message: this.message
    };

    if (this.selectedUserType === 'vendor') {
      payload.vendor_id = this.selectedVendorId;
    } else if (this.selectedUserType === 'staff') {
      payload.staff_id = this.selectedVendorId;
    } else if (this.selectedUserType === 'admin') {
      payload.admin_id = this.selectedVendorId;
    }

    this.request.POST('chat/conversations/start', payload).subscribe(
      (response: any) => {
        console.log('Message sent:', response);
        this.isSending = false;
        
        if (response['status']) {
          if (response['data']?.conversation_id) {
            this.conversationId = response['data'].conversation_id;
          }
          
          // Add the sent message to the messages array immediately
          const newMessage = {
            id: Date.now(),
            conversation_id: this.conversationId,
            sender_id: this.currentUserId,
            subject: subjectToSend,
            body: this.message,
            created_at: new Date().toISOString(),
            read_at: null
          };
          this.messages.push(newMessage);
          this.lastSubject = subjectToSend;
          
          // Keep subject field empty; last subject is reused silently on next send
          this.subject = '';
          this.message = '';
        } else {
          // Handle error from API
          console.error('Failed to send message:', response['message'] || response['error']);
          alert(response['message'] || 'Failed to send message. Please try again.');
        }
      },
      (err) => {
        console.error('Error sending message:', err);
        this.isSending = false;
        alert('Failed to send message. Please try again.');
      }
    );
  }

  closeSidebar() {
    document.body.style.overflow = '';
    this.closeSidebarEvent.emit();
  }
}
